import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ResultDialogComponent } from '../result-dialog/result-dialog.component';
import { Subscription } from 'rxjs/Subscription';

import { AuthGuardService, CommercialService, UserService } from '@core/services';
import { User } from '@shared/models';

@Component({
  selector: 'app-mailing-address',
  templateUrl: './mailing-address.component.html',
  styleUrls: ['./mailing-address.component.css']
})
export class MailingAddressComponent implements OnInit {

  updateMailingAddress: FormGroup;
  public user: User;
  private subscription: Subscription;
  private commercialSubscription: Subscription;
  public errorMessage = '';
  public rawPhone = '';
  public rawPhone2 = '';
  isCommercial: any;


  constructor(private _fb: FormBuilder,
    private _userService: UserService,
    private _router: Router,
    private _authGuard: AuthGuardService,
              private _commercial: CommercialService,
              private dialog: MatDialog) { }

  ngOnInit() {
    this.updateMailingAddress = this._fb.group({
      BusinessName: new FormControl('', ),
      FirstName: new FormControl('', Validators.required, ),
      LastName: new FormControl('', Validators.required),
      Address: new FormControl('', Validators.required),
      Address2: new FormControl('', ),
      City: new FormControl('', Validators.required),
      StateProvince: new FormControl('', Validators.required),
      ZipPostal: new FormControl('', [Validators.required, Validators.maxLength(10)]),
      Phone1: new FormControl('', [Validators.required, Validators.maxLength(15)]),
      Phone2: new FormControl('', Validators.maxLength(15)),

    });

    this.subscription = this._userService.getUser().subscribe(user => {
      this.user = user;
      if(this.user.customerIdArray){
        if(this.user.customerIdArray[this.user.customerIndex]){
          this.setDefaults();
        }
      }
    });

    this.commercialSubscription = this._commercial.getCommercialValue().subscribe(isCommercial => {
      this.isCommercial = isCommercial;
    })


    this.setDefaults();
  }
  ngOnDestroy() {
    if(this.subscription){
    this.subscription.unsubscribe();
    }
    this.commercialSubscription.unsubscribe();
  }

  onSubmit() {
    console.log("Submitting mailing address");
    let mailingAddressData = this.setupMailingData();

    console.log(this.rawPhone);
    console.log(this.rawPhone2);
    console.log('Data for mailing', mailingAddressData);

    const insertBillingAddressEndpoint = 'portfolios/UpdateMailing';
    this._authGuard.authenticatedPost(insertBillingAddressEndpoint, mailingAddressData).subscribe(
      result => {
        // TODO need to either refresh user or set the billing address of the customer here
        let rawMailingAddress: any;
        rawMailingAddress = result;
        console.log(rawMailingAddress);
        this._userService.setMailingAddress(rawMailingAddress.Country,rawMailingAddress.City, rawMailingAddress.Email, rawMailingAddress.Phone1, rawMailingAddress.Phone2, rawMailingAddress.PostalCode, rawMailingAddress.Province, rawMailingAddress.Street, rawMailingAddress.Street2);
          let dialogRef = this.dialog.open(ResultDialogComponent, {
              data: {
                  message: 'You have successfully updated your mailing address',
                  alertType: 'success',
                  title: 'Mailing Address Updated'
              }
          });
      },
      error => {
          let dialogRef = this.dialog.open(ResultDialogComponent, {
              data: {
                message: error,
                  alertType: 'danger',
                  title: 'Failed To Update Mailing Address'
              }
          });
        this.errorMessage = error;
      });
  }

  setDefaults() {
    const currentCustomer = this.user.customerIdArray[this.user.customerIndex];
    const currentMailingAddress = currentCustomer.MailingAddress;
    const businessName = currentCustomer.BusinessName;
    const firstName = currentCustomer.FirstName;
    const lastName = currentCustomer.LastName;

    this.rawPhone = currentMailingAddress.Phone1;
    this.rawPhone2 = currentMailingAddress.Phone2;

    this.updateMailingAddress.patchValue({
      name: currentMailingAddress.NameOnCard,
      Address: currentMailingAddress.Street,
      Address2: currentMailingAddress.Street2,
      City: currentMailingAddress.City,
      StateProvince: currentMailingAddress.Province,
      ZipPostal: currentMailingAddress.PostalCode,
      Phone1: currentMailingAddress.Phone1,
      Phone2: currentMailingAddress.Phone2,
      BusinessName: businessName,
      FirstName: firstName,
      LastName: lastName
    });
  }

  setupMailingData() {
    const currentCustomer = this.user.customerIdArray[this.user.customerIndex];

    return {
      "CustomerId": currentCustomer.Id,
      "BusinessName": this.updateMailingAddress.value.BusinessName,
      "Address": this.updateMailingAddress.value.Address,
      "Address2": this.updateMailingAddress.value.Address2,
      "City": this.updateMailingAddress.value.City,
      "StateProvince": this.updateMailingAddress.value.StateProvince,
      "ZipPostal": this.updateMailingAddress.value.ZipPostal,
      "PrimaryTx": this.rawPhone,
      "SecondaryTx": this.rawPhone2,
      "FirstName": this.updateMailingAddress.value.FirstName,
      "LastName": this.updateMailingAddress.value.LastName,
      "Email": currentCustomer.MailingAddress.Email
    }


  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/mailing-address/mailing-address.component.ts